// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "can_create_proposals": {
      "column": {
        "default": true,
        "name": "can_create_proposals",
        "null": false,
        "type": "boolean"
      },
      "name": "can_create_proposals",
      "selected_by_default": null,
      "translated": false
    },
    "deadline_for_proposals_at": {
      "column": {
        "default": null,
        "name": "deadline_for_proposals_at",
        "null": true,
        "type": "datetime"
      },
      "name": "deadline_for_proposals_at",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "internal": {
      "column": {
        "default": false,
        "name": "internal",
        "null": false,
        "type": "boolean"
      },
      "name": "internal",
      "selected_by_default": null,
      "translated": false
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": null,
      "translated": true
    },
    "proposals_count": {
      "column": {
        "default": 0,
        "name": "proposals_count",
        "null": false,
        "type": "integer"
      },
      "name": "proposals_count",
      "selected_by_default": null,
      "translated": false
    },
    "public_access": {
      "column": {
        "default": false,
        "name": "public_access",
        "null": false,
        "type": "boolean"
      },
      "name": "public_access",
      "selected_by_default": null,
      "translated": false
    },
    "speaker_list_when_in_live": {
      "column": {
        "default": false,
        "name": "speaker_list_when_in_live",
        "null": false,
        "type": "boolean"
      },
      "name": "speaker_list_when_in_live",
      "selected_by_default": null,
      "translated": false
    },
    "visible_for_others_than_creator": {
      "column": {
        "default": true,
        "name": "visible_for_others_than_creator",
        "null": false,
        "type": "boolean"
      },
      "name": "visible_for_others_than_creator",
      "selected_by_default": null,
      "translated": false
    },
    "users_can_write_comments": {
      "column": {
        "default": true,
        "name": "users_can_write_comments",
        "null": false,
        "type": "boolean"
      },
      "name": "users_can_write_comments",
      "selected_by_default": null,
      "translated": false
    }
  },
  "className": "ProposalType",
  "collectionKey": "proposal_types",
  "collectionName": "proposal_types",
  "i18nKey": "proposal_type",
  "camelizedLower": "proposalType",
  "name": "ProposalType",
  "nameDasherized": "proposal-type",
  "pluralName": "proposal_types",
  "ransackable_associations": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "belongs_to",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "ProposalType::Translation",
      "collectionName": null,
      "foreignKey": "proposal_type_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "ProposalType::Translation",
      "collectionName": null,
      "foreignKey": "proposal_type_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "activity_id",
      "column": {
        "default": null,
        "name": "activity_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "can_create_proposals",
      "column": {
        "default": true,
        "name": "can_create_proposals",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "deadline_for_proposals_at",
      "column": {
        "default": null,
        "name": "deadline_for_proposals_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "internal",
      "column": {
        "default": false,
        "name": "internal",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "old_activity_id",
      "column": {
        "default": null,
        "name": "old_activity_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "proposals_count",
      "column": {
        "default": 0,
        "name": "proposals_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "public_access",
      "column": {
        "default": false,
        "name": "public_access",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "speaker_list_when_in_live",
      "column": {
        "default": false,
        "name": "speaker_list_when_in_live",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "users_can_write_comments",
      "column": {
        "default": true,
        "name": "users_can_write_comments",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "visible_for_others_than_creator",
      "column": {
        "default": true,
        "name": "visible_for_others_than_creator",
        "null": false,
        "type": "boolean"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "proposal_type",
  "primaryKey": "id"
}

/** Frontend model for ProposalType. */
export default class ProposalType extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {boolean} */
  canCreateProposals() {
    return this.readAttributeUnderscore("can_create_proposals")
  }

  /** @returns {boolean} */
  hasCanCreateProposals() {
    const value = this.canCreateProposals()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  deadlineForProposalsAt() {
    return this.readAttributeUnderscore("deadline_for_proposals_at")
  }

  /** @returns {boolean} */
  hasDeadlineForProposalsAt() {
    const value = this.deadlineForProposalsAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  internal() {
    return this.readAttributeUnderscore("internal")
  }

  /** @returns {boolean} */
  hasInternal() {
    const value = this.internal()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {number} */
  proposalsCount() {
    return this.readAttributeUnderscore("proposals_count")
  }

  /** @returns {boolean} */
  hasProposalsCount() {
    const value = this.proposalsCount()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  publicAccess() {
    return this.readAttributeUnderscore("public_access")
  }

  /** @returns {boolean} */
  hasPublicAccess() {
    const value = this.publicAccess()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  speakerListWhenInLive() {
    return this.readAttributeUnderscore("speaker_list_when_in_live")
  }

  /** @returns {boolean} */
  hasSpeakerListWhenInLive() {
    const value = this.speakerListWhenInLive()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  visibleForOthersThanCreator() {
    return this.readAttributeUnderscore("visible_for_others_than_creator")
  }

  /** @returns {boolean} */
  hasVisibleForOthersThanCreator() {
    const value = this.visibleForOthersThanCreator()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  usersCanWriteComments() {
    return this.readAttributeUnderscore("users_can_write_comments")
  }

  /** @returns {boolean} */
  hasUsersCanWriteComments() {
    const value = this.usersCanWriteComments()

    return this._isPresent(value)
  }
}
